import 'src/css/aiassistant.css';
import { withTranslation } from "react-i18next";
import { Col, Row, Button } from 'react-bootstrap';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { compose } from 'redux';
import { useNavigate } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { duotone } from '@fortawesome/fontawesome-svg-core/import.macro';

class AssinstantMessage extends Component {
    constructor() {
        super();
        this.copy = this.copy.bind(this);
    }

    async copy() {
        if (!this.props.message) {
            console.error('No message to copy.');
            return;
        }

        try {
            await navigator.clipboard.writeText(this.props.message);
            console.log('Text copied to clipboard!');
        } catch (err) {
            console.error('Failed to copy text: ', err);
            alert("Failed to copy text. Please ensure the page is focused and permissions are granted.");
        }
    }

    render() {

        return (
            <Row className='aimessage'>
                <Row>
                    <Col>
                        <div className='aiicon text-primary'>
                            <FontAwesomeIcon size='xl' icon={duotone('microchip-ai')} />
                        </div>

                    </Col>
                </Row>
                <Row>
                    <Col>
                        <p className='aitext text-gray-800'>{this.props.message}</p>
                    </Col>
                </Row>
                <Row>
                    <Col>
                        <Button className='aicopy' variant="light" size='sm' onClick={this.copy}><FontAwesomeIcon icon={duotone('copy')} />{this.props.t("copy")}</Button>
                    </Col>
                </Row>
            </Row>);
    }
}


const mapStateToProps = (state) => {
    return {
        photo: state.agent.photo,
        initials: state.agent.initials,
    };
};

function WithNavigate(props) {
    let navigate = useNavigate();
    return <AssinstantMessage {...props} navigate={navigate} />
}

export default compose(connect(mapStateToProps, {}), withTranslation())(WithNavigate);